import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import { GOOGLE_OAUTH_CLIENT_ID, GOOGLE_OAUTH_ENABLED } from './googleOAuth';

export default function GoogleOAuthBoundary({
  children,
  enabled = GOOGLE_OAUTH_ENABLED,
  clientId = GOOGLE_OAUTH_CLIENT_ID,
}) {
  const normalizedClientId = typeof clientId === 'string' ? clientId.trim() : '';
  if (!enabled || !normalizedClientId) {
    return children;
  }
  return (
    <GoogleOAuthProvider clientId={normalizedClientId}>
      {children}
    </GoogleOAuthProvider>
  );
}
